import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
} from "../../../components/card/card.jsx";
import {  useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {

  workOrder,
 
} from "../../../api/index.js";

import {
  
  formatDateOnly,
  getStatusColor,
  
} from "../../../utils/helper.jsx";
import { format } from "date-fns";
import DataTable from "react-data-table-component";
import ConfirmationDlg from "../../../components/ConfirmationDlg/index.jsx";
import { PermissionChecker } from "../../../components/PermissionChecker/index.jsx";



function WorkOrderTab({ assetId }) {
  let { id } = useParams();
  if (!id) id = assetId;

  const navigate = useNavigate();
 
  const [loading, setLoading] = useState(false);

  const [deleteRow, setDeleteRow] = useState(null);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
 
  const [datas, setDatas] = useState([]);
 
  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
        asset_id: id,
        isRequest: false,
      };

      const res = await workOrder.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  
  async function deleteData() {
    try {
      const response = await workOrder.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This Work Order has been deleted");

          setDeleteRow(null);
          await getData();
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page, query.take]);

  
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">More detail</div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Asset</label>
                      <p>{data?.asset?.asset_name}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Category</label>
                      <p>{data?.category?.name}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Priority</label>
                      <p>{data.priority}</p>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted By</label>
                      <p>{data.created_by_user?.firstname}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted At</label>
                      <p>
                        {format(new Date(data.created_at), "yyyy-MM-dd hh:mm")}
                      </p>
                    </div>
                  </div>
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate("/work-order/detail/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>

                <button
                  onClick={() => navigate("/work-order/edit/" + data.id)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-warning"
                >
                  <i className="fa fa-edit"></i> Edit Work Order
                </button>

                <PermissionChecker permissions={["delete work order"]} hideIfNotAllowed>
                <button
                  onClick={() => showConfirmationDlg(data)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-danger"
                >
                  <i className="fa fa-edit"></i> Delete Work Order
                                </button>
                                </PermissionChecker>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  let columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      minWidth: "150px",
    },

    {
      name: "Category",
      selector: (row) => row.category?.name,
    },

    {
      name: "Priority",
      selector: (row) => row.priority,
      cell: (row) => (
        <span
          className={`badge border ${
            row.priority === "high"
              ? "border-danger text-danger"
              : row.priority === "medium"
              ? "border-warning text-warning"
              : "border-success text-success"
          }`}
          style={{ textTransform: "capitalize" }}
        >
          {row.priority}
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`badge border border-${getStatusColor(
            row.status
          )} text-${getStatusColor(row.status)}`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Start Date",
      selector: (row) => row.start_date,
      cell: (row) => formatDateOnly(row.start_date),
    },
    {
      name: "Due Date",
      selector: (row) => row.due_date,
      cell: (row) => formatDateOnly(row.due_date),
    },
    {
      name: "Submitted By",
      selector: (row) => row.created_by_user?.firstname,
    },
    {
      name: "Submitted At",
      selector: (row) => row.created_at,
      cell: (row) => formatDateOnly(row.created_at),
    },
  ];

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  return (
    <div>
      

                    <div style={{ display: "flex", justifyContent: "end" }}>
                    <button
                      onClick={() => navigate("/work-order/add")}
                      className="btn btn-outline-theme"
                    >
                      Create Work Order
                    </button>
                  </div>
                  <hr />

                  <Card>
                    <CardBody>
                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        highlightOnHover
                        expandOnRowClicked
                        expandableRowsHideExpander
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        onChangeRowsPerPage={(row) =>
                          setQuery((prev) => ({
                            ...prev,
                            page: 1,
                            take: row,
                          }))
                        }
                        paginationTotalRows={query.totalData}
                        onChangePage={(page) =>
                          setQuery((prev) => ({ ...prev, page: page }))
                        }
                      />
                    </CardBody>
                  </Card>
       

          {deleteRow && (
            <ConfirmationDlg
              title={"Delete Work Order"}
              open={!!deleteRow}
              onClose={hideConfirmationDialog}
              onSubmit={deleteData}
            >
              <p style={{ pb: 2 }}>
                Are you sure you want to delete this work order{" "}
                <strong>{deleteRow.title}</strong> ?
              </p>
            </ConfirmationDlg>
          )}
       
     
    </div>
  );
}

export default WorkOrderTab;
